import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Drawer, Popover, Progress, Rate,
} from 'antd';
import ProductActions from '@Actions/productActions';
import SellerActions from '@Actions/sellerActions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import VendorAddresses from '@Components/Vendors/VendorProfile/VendorOverview/VendorAddresses';
import Helpers from '@Apis/helpers';
import { CountryCodes } from '@Apis/constants';
import VendorForm from '@Components/Common/VendorForm';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';
import SelectCustomer from '@Components/Common/SelectCustomer';
import './style.scss';
import H3Progress from '@Components/Common/H3Progress';
import { EditOutlined } from '@ant-design/icons';
import UpdateTallyVendors from '../../../Common/UpdateTallyLedger/UpdateTallyVendors';

/**
 *
 */
class VendorProducts extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      showLinkCustomerPopup: false,
      isDrawerOpen: false,
    };
  }

  /**
   *
   */
  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getSellerByIdLoading, selectedSeller, getSellerById, user, match, linkCustomerLoading, linkCustomer, MONEY,
    } = this.props;
    const {
      showEditSellerDrawer, selectedCustomer, showLinkCustomerPopup, isDrawerOpen,
    } = this.state;
    return (
      <Fragment>
        <div className="vendor-overview__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-8 ant-col-xs-24">
              <div>
                <div className="vendor-overview__left">
                  <div className="vendor-overview__left-header">
                    <div className="vendor-overview__left-heading">
                      VENDOR INFORMATION
                    </div>
                    {Helpers.getPermission(Helpers.permissionEntities.VENDORS, Helpers.permissionTypes.UPDATE, user) && (
                      <div
                        className="vendor-overview__left-sub"
                        onClick={() => this.setState({ showEditSellerDrawer: true })}
                      >
                        Edit
                      </div>
                    )}
                  </div>

                  <div className=" vendor-overview__left__unit-info">
                    {!getSellerByIdLoading
                      ? (
                        <React.Fragment>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Contact Person
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.contact_person_1 || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Vendor Type
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.seller_type?.toProperCase() || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Marketplace Vendor
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.is_marketplace_seller ? 'Yes' : 'No'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Phone
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.mobile_1 ? (`${CountryCodes?.find((code) => code?.dial_code == selectedSeller?.seller_info?.dial_code)?.flag} +${selectedSeller?.seller_info?.dial_code} ${selectedSeller?.seller_info?.mobile_1}`) : '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Email
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.email_id_1 || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Fax
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.fax_no || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Currency
                            </div>
                            <div className="unit-info-row__value">
                              {`${selectedSeller?.currency_info?.currency_code}(${selectedSeller?.currency_info?.currency_symbol})`}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              GST Number
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.gst_number || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Payment Terms
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.default_payment_terms?.due_days == 0 ? 'On Delivery' : `${selectedSeller?.seller_info?.default_payment_terms?.due_days} Days Credit`}
                            </div>
                          </div>
                          {user?.tenant_info?.zoho_branch_id && (
                            <div className="unit-info-row">
                              <div className="unit-info-row__label">
                                Zoho Reference ID
                              </div>
                              <div className="unit-info-row__value">
                                <a href={`https://books.zoho.in/app#/vendors/${selectedSeller?.zoho_seller_id}`} target="_blank" rel="noreferrer">
                                  {selectedSeller?.zoho_seller_id || '-'}
                                </a>
                              </div>
                            </div>
                          )}
                          {user?.tenant_info?.it_id && (

                            <div className="unit-info-row">
                              <div className="unit-info-row__label">
                                Tally Vendor Name
                              </div>
                              <div className="unit-info-row__value">
                                <div style={{ display: 'flex', marginLeft: '3px', alignItems: 'center' }}>
                                  <div className="unit-info__header-title">
                                    {selectedSeller?.tally_sellers?.[0]?.seller_name}
                                  </div>
                                  <div>
                                    <div
                                      className="roundIconButton"
                                      onClick={() => {
                                        this.setState({ isDrawerOpen: true });
                                      }}
                                    >
                                      <EditOutlined />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {selectedSeller?.custom_fields?.length > 0 && (
                            <ViewCustomFields
                              customFields={selectedSeller?.custom_fields?.filter((cf) => cf.is_active)}
                              wrapperClass="unit-info-row"
                              labelClass="unit-info-row__label"
                              valueClass="unit-info-row__value"
                            />
                          )}
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Linked Customer
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.customer_id ? <Link to={`/sales/customer/view/${selectedSeller?.seller_info?.customer_id}`} targt="_blank">{selectedSeller?.seller_info?.customer_name}</Link> : (
                                <Popover
                                  placement="topLeft"
                                  title="Link vendor to a customer"
                                  open={showLinkCustomerPopup}
                                  content={(
                                    <div className="link-customer__wrapper">
                                      <Alert
                                        message="This will allow you to view combined statement for the customer from the vendor's overview section."
                                        type="warning"
                                        showIcon
                                      />
                                      <SelectCustomer
                                        showAddCustomer={false}
                                        selectedCustomer={selectedCustomer}
                                        onChange={(value) => {
                                          this.setState({
                                            selectedCustomer: value?.customer_id,
                                          });
                                        }}
                                        tenantId={selectedSeller?.tenant_id}
                                        showError={false}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        hideCustomersLinkedToVendors
                                      />
                                      <div style={{ display: 'flex', marginTop: '15px' }}>
                                        <Button
                                          onClick={() => {
                                            if (selectedCustomer) {
                                              linkCustomer({
                                                seller_id: selectedSeller?.seller_id,
                                                customer_id: selectedCustomer,
                                              }, () => {
                                                getSellerById(match?.params?.vendorId, user?.tenant_info?.tenant_id);
                                                this.setState({ showLinkCustomerPopup: false });
                                              });
                                            }
                                          }}
                                          size="small"
                                          type="primary"
                                          loading={linkCustomerLoading}
                                        >
                                          Link Customer
                                        </Button>
                                        <Button
                                          onClick={() => this.setState({ showLinkCustomerPopup: false })}
                                          size="small"
                                          type="default"
                                          style={{ marginLeft: '5px' }}
                                          disabled={linkCustomerLoading}
                                        >
                                          Cancel
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                  trigger="click"
                                >
                                  <H3Text
                                    text="Link"
                                    className="unit-info-row__value-link"
                                    onClick={() => this.setState({ showLinkCustomerPopup: true })}
                                  />
                                </Popover>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      )

                      : (
                        <React.Fragment>
                          {[1, 2, 3, 4]?.map((item) => (
                            <div key={item} className="vendor-overview__loader">
                              <div className="loadingBlock loader-line" />
                            </div>
                          ))}

                        </React.Fragment>
                      )}

                  </div>
                </div>
              </div>
              <div>
                <div className="vendor-overview__left">
                  <div className="vendor-overview__left-header">
                    <div className="vendor-overview__left-heading">
                      PAYMENT INFORMATION
                    </div>
                  </div>
                  <div className=" vendor-overview__left__unit-info">
                    {!getSellerByIdLoading
                      ? (
                        <React.Fragment>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Bank Account Name
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.bank_name || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Bank Account Number
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.bank_account_no || '-'}
                            </div>
                          </div>
                          <div className="unit-info-row">
                            <div className="unit-info-row__label">
                              Bank IFSC
                            </div>
                            <div className="unit-info-row__value">
                              {selectedSeller?.seller_info?.bank_ifsc || '-'}
                            </div>
                          </div>
                        </React.Fragment>
                      )

                      : (
                        <React.Fragment>
                          {[1, 2, 3, 4]?.map((item) => (
                            <div key={item} className="vendor-overview__loader">
                              <div className="loadingBlock loader-line" />
                            </div>
                          ))}

                        </React.Fragment>
                      )}

                  </div>
                </div>
              </div>
            </div>
            <div className="ant-col-md-8 ant-col-xs-24">
              <VendorAddresses />
            </div>
            <div className="ant-col-md-8 ant-col-xs-24">
              <div className="vendor-overview__metrics-wrapper">
                <div className="vendor-overview__metric">
                  <H3Text text="Outstanding Payable" className="vendor-overview__metric-label" />
                  <H3Text text={MONEY(Number(selectedSeller?.outgoing_payable))} className="vendor-overview__metric-value" />
                </div>
                <div className="vendor-overview__metric">
                  <H3Text text="Unused Credits" className="vendor-overview__metric-label" />
                  <H3Text text={MONEY(Number(selectedSeller?.unused_credits))} className="vendor-overview__metric-value" />
                </div>
                {user?.tenant_info?.seller_rating_config?.is_active && (
                  <div
                    className="vendor-rating__metric"

                  >
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      />
                      <div className="vendor-overview__rating-main">
                        <Rate
                          allowHalf
                          value={selectedSeller?.rating}
                          disabled
                          style={{ fontSize: '18px' }}
                        />
                        <H3Text text={`${selectedSeller?.rating || 0} out of 5`} className="vendor-overview__rating-main-text" />
                      </div>
                      <div>
                        <div className="custom-rating-item">
                          <H3Text text="On Time Delivery" className="custom-reason-title" />
                          <Progress
                            percent={Number(selectedSeller?.delivery_timeliness)}
                            status="active"
                            strokeColor={{ from: '#108ee9', to: '#87d068' }}
                            trailColor="#2d7df71a"
                          />
                        </div>
                        <div className="custom-rating-item">
                          <H3Text text="Fill Rate" className="custom-reason-title" />
                          <Progress
                            percent={Number(selectedSeller?.fill_rate)}
                            status="active"
                            strokeColor={{ from: '#108ee9', to: '#87d068' }}
                            trailColor="#2d7df71a"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>

            </div>
          </div>

        </div>
        <Drawer
          open={showEditSellerDrawer}
          onClose={() => this.setState({ showEditSellerDrawer: false })}
          width="720px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '680px' }}>
              <H3Text text="Update Vendor Information" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showEditSellerDrawer: false })} />
            </div>
          </div>
          <VendorForm
            selectedSeller={selectedSeller}
            callback={() => {
              getSellerById(match?.params?.vendorId, user?.tenant_info?.tenant_id);
              this.setState({ showEditSellerDrawer: false });
            }}
          />
        </Drawer>
        <Drawer
          open={isDrawerOpen}
          onClose={() => this.setState({ isDrawerOpen: false })}
          width="720px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '680px' }}>
              <H3Text text="Update Tally Customer" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ isDrawerOpen: false })} />
            </div>
          </div>
          <UpdateTallyVendors
            data={Array.isArray(selectedSeller) ? selectedSeller : [selectedSeller]}
            callback={() => {
              getSellerById(match?.params?.vendorId, user?.tenant_info?.tenant_id);
              this.setState({ isDrawerOpen: false });
            }}
          />
        </Drawer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  SellerReducers, UserReducers, ProductReducers,
}) => ({
  getSellerByIdLoading: SellerReducers.getSellerByIdLoading,
  selectedSeller: SellerReducers.selectedSeller,
  updateSellerOffersLoading: SellerReducers.updateSellerOffersLoading,
  selectedSellerOffers: SellerReducers.selectedSellerOffers,
  getSellerOffersByIdLoading: SellerReducers.getSellerOffersByIdLoading,
  pincodeCity: SellerReducers.pincodeCity,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  sellerProducts: ProductReducers.sellerProducts,
  getSellerProductsLoading: ProductReducers.getSellerProductsLoading,
  linkCustomerLoading: SellerReducers.linkCustomerLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getSellerById: (vendorId, tenantId) => dispatch(SellerActions.getSellerById(vendorId, tenantId)),
  updateSeller: (payload) => dispatch(SellerActions.updateSeller(payload, '')),
  updateSellerOffers: (payload, callback) => dispatch(SellerActions.updateSellerOffers(payload, callback)),
  getSellerOffersById: (vendorId, page) => dispatch(SellerActions.getSellerOffersById(vendorId, page)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  getSellerProducts: (tenantId, sellerId, productName, page, limit) => dispatch(ProductActions.getSellerProducts(tenantId, sellerId, productName, page, limit)),
  linkCustomer: (payload, callback) => dispatch(SellerActions.linkCustomer(payload, callback)),
});

VendorProducts.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  getSellerById: PropTypes.func,
  selectedSeller: PropTypes.any,
  getSellerByIdLoading: PropTypes.bool,
  linkCustomerLoading: PropTypes.bool,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VendorProducts));
